var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.6 14.8",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart_1_",
    transform: "translate(0 -31.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    cx: 7.4,
    cy: 44.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    cx: 12,
    cy: 44.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    d: "M0.6,32.1h2l2.3,8l-0.2,0.4c-0.4,0.7-0.1,1.6,0.6,1.9c0.2,0.1,0.4,0.1,0.6,0.1h8c0.3,0,0.5-0.2,0.5-0.5 s-0.2-0.5-0.5-0.5l0,0h-8c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0-0.1,0.1-0.2l0.2-0.2H14c0.2,0,0.4-0.1,0.5-0.3l1.9-6.7 c0.1-0.3-0.1-0.5-0.3-0.6H16H4l-0.4-1.6c-0.1-0.2-0.2-0.3-0.5-0.3H0.6c-0.3,0-0.5,0.2-0.5,0.5C0.2,31.9,0.4,32.1,0.6,32.1L0.6,32.1 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.6c26fc1a.svg";
export { ForwardRef as ReactComponent };